import React from 'react';
import { Grid, Typography, Divider, Button } from '@mui/material';
import { grey } from '@mui/material/colors';
import {
  formatDateUTCFormat,
  formatNumberWithCommas,
  getOrdinal
} from '../apis/Utils';

const ShipmentDetailsComponent = ({
  shipmentsDetails = [],
  groupedPickupDetails = {},
  groupedDeliveryDetails = {},
  previousRowDetails = {},
  quoteMode = ''
}) => {
  const renderLocationCard = (
    item,
    index,
    type,
    currentGroupedData,
    typeofData
  ) => {
    const pickupIncludes =
      previousRowDetails?.TLPickupMode !== undefined &&
      previousRowDetails?.TLPickupMode?.includes('1 Pickup');
    const quoteIncludes = previousRowDetails?.quoteMode?.includes('1 Drop');
    const label =
      !pickupIncludes && !quoteIncludes
        ? `${getOrdinal(index + 1)} ${type}`
        : `${type} Item `;

    return (
      <Grid item xs={12} key={`${type}-${index}`}>
        {typeofData !== 'instructions' &&
          index === 0 &&
          item.itemType === 'Pickup' && (
            <Grid>
              <b style={{ color: '#2563eb', fontSize: 14 }}>Shipment Details</b>

              {item.isHazmat && (
                <Button
                  disabled
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    height: 16,
                    width: 30,
                    fontWeight: 'bold',
                    backgroundColor: 'red !important',
                    color: 'white !important',
                    borderRadius: '8px',
                    padding: '0 8px',
                    cursor: 'default'
                  }}
                  variant='contained'
                  size='small'
                >
                  Hazmat
                </Button>
              )}
            </Grid>
          )}

        {typeofData !== 'instructions' && (
          <>
            <Grid
              container
              // gap={3}
              // spacing={0.5}
              sx={{ my: 3, backgroundColor: '#EEF4FC', p: 1, borderRadius: 2 }}
            >
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'>Net Weight (lbs)</div>
                <div className='rating_scree_value'>
                  {formatNumberWithCommas(item.netWeight)}
                </div>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'>Gross Weight (lbs)</div>
                <div className='rating_scree_value'>
                  {formatNumberWithCommas(item.grossWeight)}
                </div>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'>Handling Unit</div>
                <div className='rating_scree_value'>{item.packagingType}</div>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'># of Handling Unit</div>
                <div className='rating_scree_value'>
                  {item.units || item.pallets}
                </div>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'>Dimensions (in)</div>
                <div className='rating_scree_value'>
                  {item.length} x {item.width} x {item.height}
                </div>
              </Grid>

              <Grid
                item
                xs={2}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className='rating_scree_label'>Stackable?</div>
                <div className='rating_scree_value'>
                  {item.isStackable ? 'Yes' : 'No'}
                </div>
              </Grid>
              {item.itemType === 'Pickup' && (
                <Grid
                  item
                  xs={2}
                  sx={{ display: 'flex', flexDirection: 'column' }}
                >
                  <div className='rating_scree_label'>Freight Class</div>
                  <div className='rating_scree_value'>{item.freightClass}</div>
                </Grid>
              )}

              <Grid sx={{ mt: 0 }}>
                <div className='rating_scree_label'>Item Description</div>

                <div className='rating_scree_value'>
                  {item.itemDescription || item.itemText}
                </div>
              </Grid>
            </Grid>
          </>
        )}

        {previousRowDetails?.pickupInstructions &&
          typeofData === 'instructions' &&
          item.itemType === 'Pickup' &&
          index === 0 && (
            <Grid sx={{ my: 2 }}>
              <Typography variant='caption' color={grey[600]} mt={1}>
                Pickup Instructions
              </Typography>
              <br />
              <Typography variant='caption' fontWeight={600}>
                {previousRowDetails.pickupInstructions}
              </Typography>
            </Grid>
          )}
      </Grid>
    );
  };

  const renderInstrcutions = (groupedData, type) =>
    Object.entries(groupedData).map(([address, items], index) => {
      if (index === 0) {
        return (
          <Grid
            sx={{
              backgroundColor: '#EEF4FC',
              borderRadius: 2,
              padding: 1,
              my: 2
            }}
          >
            <Grid>
              {index === 0 && items[0].itemType === 'Delivery' && (
                <Grid sx={{ mt: 2 }}>
                  <b style={{ color: '#2563eb', fontSize: 14 }}>
                    Delivery Instructions
                  </b>
                  <br />
                  <div className='rating_scree_value'>
                    {previousRowDetails.deliveryInstructions}
                  </div>
                </Grid>
              )}

              {index === 0 && items[0].itemType === 'Pickup' && (
                <Grid sx={{ mt: 2 }}>
                  <b style={{ color: '#2563eb', fontSize: 14 }}>
                    Pickup Instructions
                  </b>
                  <br />
                  <div className='rating_scree_value'>
                    {previousRowDetails.pickupInstructions}
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        );
      }
    });

  const renderVerticalList = (groupedData, type) =>
    Object.entries(groupedData).map(([address, items], index) => {
      return (
        <Grid
          sx={{
            my: 2,
            borderRadius: 2
            // p: 1
          }}
        >
          {items.map((item, itemIndex) =>
            renderLocationCard(item, itemIndex, type, groupedData)
          )}
        </Grid>
      );
    });
  const formatAddressForDisplay = (company, fullAddress) => {
    if (!fullAddress) return company || '';

    // Pattern for: street-city-state-zip-country
    const dashPattern =
      /^([A-Za-z0-9\s-]+)-([A-Za-z\s]+)-([A-Z]{2})-(\d{5}(?:-\d{4})?)-?([A-Za-z]*)$/;
    const match = fullAddress.match(dashPattern);

    if (match) {
      const [, street, city, state, zip, country] = match;
      const formattedLocation = `${city}, ${state} ${zip}${
        country ? `, ${country}` : ''
      }`;

      if (company) {
        return `${company}, ${street}, ${formattedLocation}`;
      } else {
        return `${street}, ${formattedLocation}`;
      }
    } else {
      // Try comma-separated format
      const commaParts = fullAddress.split(',');
      if (commaParts.length > 1) {
        const street = commaParts[0];
        const location = commaParts.slice(1).join(',').replace(/-/g, ', ');

        if (company) {
          return `${company}, ${street}, ${location}`;
        } else {
          return `${street}, ${location}`;
        }
      } else {
        // Fallback
        if (company) {
          return `${company}, ${fullAddress}`;
        } else {
          return fullAddress;
        }
      }
    }
  };
  const renderPickDeliveryAddress = (groupedData, type) =>
    Object.entries(groupedData).map(([address, items], index) => (
      <Grid
        key={`${address}-${type}`}
        sx={{
          backgroundColor: '#EEF4FC',
          borderRadius: 2,
          padding: 1,
          mb: 2
        }}
      >
        {index === 0 && (
          <b style={{ color: '#2563eb', fontSize: 14 }}>
            {type === 'Drop' || type === 'Delivery' ? 'Delivery' : type}{' '}
            information
          </b>
        )}
        <br />
        <Grid>
          <Grid>
            <div style={{ marginTop: 5 }} className='rating_scree_label'>
              {type === 'Pickup'
                ? quoteMode.includes('Multiple Pickups')
                  ? `${type} Address ${index + 1}`
                  : `${type} Address`
                : type === 'Drop' || type === 'Delivery'
                  ? quoteMode.includes('Multiple Drops')
                    ? `${type} Address ${index + 1}`
                    : `Delivery Address`
                  : `Delivery Address`}
            </div>
            <div className='rating_scree_value'>
              {items?.length
                ? [
                    items[0].company,
                    items[0].address,
                    items[0].city,
                    items[0].state,
                    items[0].zip,
                    items[0].country
                  ]
                    .filter(Boolean)
                    .join(', ')
                : 'No address available'}
            </div>
            {items
              .filter(items => items.itemType === 'Pickup')
              .map(
                (items, index) =>
                  index === 0 && (
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        mt: 2
                      }}
                    >
                      <Grid
                        xs={4}
                        item
                        sx={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <div className='rating_scree_label'>Pickup Date</div>

                        <div className='rating_scree_value'>
                          {formatDateUTCFormat(items.pickupDate)}
                        </div>
                      </Grid>
                      <Grid
                        xs={4}
                        item
                        sx={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <div className='rating_scree_label'>Pickup Hours</div>

                        <div className='rating_scree_value'>
                          {items.openTime} - {items.closeTime}
                        </div>
                      </Grid>
                    </Grid>
                  )
              )}
          </Grid>

          <Grid>
            {items
              .filter(items => items.itemType === 'Delivery')
              .map(
                (items, index) =>
                  index === 0 && (
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        mt: 2
                      }}
                    >
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <div className='rating_scree_label'>
                          Exp. Delivery Date
                        </div>

                        <div className='rating_scree_value'>
                          {formatDateUTCFormat(items.expectedDeliveryDate)}
                        </div>
                      </Grid>
                      <Grid
                        xs={4}
                        item
                        sx={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <div className='rating_scree_label'>Delivery Hours</div>

                        <div className='rating_scree_value'>
                          {items.openTime} - {items.closeTime}
                        </div>
                      </Grid>
                    </Grid>
                  )
              )}
          </Grid>
        </Grid>
      </Grid>
    ));

  if (!shipmentsDetails.length) {
    return null;
  }

  return (
    <>
      {/* Render pickups in vertical list */}
      {Object.keys(groupedPickupDetails).length > 0 &&
        renderVerticalList(groupedPickupDetails, 'Pickup')}

      <Grid container gap={1}>
        <Grid item md={5.9} lg={5.9} xl={5.9}>
          {Object.keys(groupedPickupDetails).length > 0 &&
            renderPickDeliveryAddress(groupedPickupDetails, 'Pickup')}
        </Grid>
        <Grid item md={5.9} lg={5.9} xl={5.9}>
          {Object.keys(groupedDeliveryDetails).length > 0 &&
            renderPickDeliveryAddress(groupedDeliveryDetails, 'Drop')}
        </Grid>
      </Grid>

      <Grid container gap={1}>
        <Grid item md={5.9} lg={5.9} xl={5.9}>
          {Object.keys(groupedPickupDetails).length > 0 &&
            renderInstrcutions(groupedPickupDetails, 'Pickup')}
        </Grid>
        <Grid item md={5.9} lg={5.9} xl={5.9}>
          {Object.keys(groupedDeliveryDetails).length > 0 &&
            renderInstrcutions(groupedDeliveryDetails, 'Drop')}
        </Grid>
      </Grid>
    </>
  );
};

export default ShipmentDetailsComponent;
